import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Data, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { LuckyNumberService } from "src/app/services/lucky-number.service";
import { IonicModule } from "@ionic/angular";

@Component({
    selector: "app-lucky-slider2",
    templateUrl: "./lucky-slider2.component.html",
    styleUrls: ["./lucky-slider2.component.scss"],
    standalone: true,
    imports: [IonicModule],
})
export class LuckySlider2Component implements OnInit {
  title: string;
  languageCode: string = "en";
  description: string;
  constructor(private router: Router, private authService: AuthService, private luckyNumberService: LuckyNumberService, private matDialog: MatDialog) {
    this.authService?.userDetails$?.subscribe((user: any) => {
      this.languageCode = user?.language_code ? user?.language_code : "en";
    });
  }
  cancelSlider2(event) {
    event.stopPropagation();
    this.router.navigateByUrl("/mainTabs/tabs/syndicate");
  }

  nextSlider(event, nextSlider) {
    event.stopPropagation();
    this.router.navigateByUrl(`/syndicate/lucky-slider${nextSlider}`);
  }

  ngOnInit(): void {
    const isEmpty = (val: any) => val === null || !(Object.keys(val) || val).length;
    this.luckyNumberService.getOnboardData("lucky_number").subscribe((onBoardRef: Data) => {
      if (onBoardRef?.exists && !isEmpty(onBoardRef?.data())) {
        const pageOneData = onBoardRef?.data();
        const pageTwoContent = pageOneData?.lucky_numbers?.page_2;
        this.description = pageTwoContent?._description ? pageTwoContent?._description?.[this.languageCode] : pageTwoContent?.description;
        this.title = pageTwoContent?._title ? pageTwoContent?._title?.[this.languageCode] : pageTwoContent?.title;
      }
    });
  }
  closePopup() {
    this.matDialog.closeAll();
  }
}
